import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <a
          className="Image-App-link"
          href="https://www.matthewhall.info/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={logo} className="App-logo" alt="Matthew Hall - brand" />
        </a>
        <p>
          MatthewHall.Studio coming soon.
        </p>
        <a
          className="App-link"
          href="https://www.matthewhall.info/"
          target="_blank"
          rel="noopener noreferrer"
        >
          until then… read more here
        </a>
      </header>
    </div>
  );
}

export default App;
